<script>
import DraggableList from './form-components/DraggableList.vue'
import simplebar from "simplebar-vue";
import Label from './form-components/Label.vue';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    listData: {
      // type: Array,
      required: true
    },
    selectedItem: {
      type: Object,
      required: true
    },
    prevSelectedItem: {
      type: String,
      required: true
    },
    setSelectedItems: {
      type: Function,
      required: false
    },
    topbarControls: {
      type: Object,
      required: false
    }
  },
  components: {
    DraggableList,
    simplebar, Label
  },
  computed: {
    totalItems() {
      return this.listData.length;
    },
    totalActiveItems() {
      return this.listData.filter((x => x.active == true)).length;
    },
    listDataGeneral() {
      return this.listData.filter((x => !x.additionalProp1 || x.additionalProp1 && !('global' in x.additionalProp1)));
    },
    listDataGlobal() {
      return this.listData.filter((x => x.additionalProp1 && x.additionalProp1.global == true));
    },
    totalItemsGlobal() {
      return this.listDataGlobal.length;
    },
    totalActiveItemsGlobal() {
      return this.listDataGlobal.filter((x => x.practices && x.practices.find(y => y.practice_id == this.currentPractice.id) ? x.practices.find(y => y.practice_id == this.currentPractice.id).active : false)).length;
    },
  },
};
</script>
<template>
  <div v-if="listData && listData.length">
    <simplebar class="simplebar-custom"
    id="scrollElement"
    data-simplebar-auto-hide="false"
  >
    <div v-if="!item.onlyGlobal" class="mb-4">
      <Label v-if="!item.empty" :item="item" :total_items="totalItems" :total_active_items="totalActiveItems"/>
      <DraggableList  :variant="item.variant" :list="listDataGeneral" :selectedItem="selectedItem"
      :setSelectedItems="setSelectedItems" :prevSelectedItem="prevSelectedItem" :topbarControls="topbarControls"
       :item="item"
      />
    </div>
    <div v-if="item.isGlobal">
      <Label v-if="!item.empty" :item="item.global" :total_items="totalItemsGlobal" :total_active_items="totalActiveItemsGlobal"/>
      <DraggableList :variant="this.$route.params.categoryName == 'globalupdate' ? '' : 'simple'" :list="listDataGlobal" :selectedItem="selectedItem"
      :setSelectedItems="setSelectedItems" :prevSelectedItem="prevSelectedItem" :topbarControls="topbarControls"
      :item="item"
      /> 
    </div> 
    </simplebar>
  </div>
  <div v-else></div>
</template>

<style scoped>
 .simplebar-custom {
   max-height: calc(100vh - 200px);
   padding-right: 2em;
 }
</style>